import { render, staticRenderFns } from "./EventAddFormIframe.vue?vue&type=template&id=73dacaf3&"
import script from "./EventAddFormIframe.vue?vue&type=script&lang=ts&"
export * from "./EventAddFormIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports